export const INPUT_TYPES = {
  TEXT: 'text',
  NUMBER: 'number',
  EMAIL: 'email',
  PASSWORD: 'password',
  TEXT_AREA: 'textarea',
  CHECK_BOX: 'checkbox',
  RADIO: 'radio',
};
